import { Routes } from '@angular/router';
import { LandingComponent } from './shell-global/landing/landing.component';
import { LoginpageComponent } from './shell-global/loginpage/loginpage.component';
import { ITInfraModule } from './features/project/IT_Infra/it-infra.module';
import { CreateuserComponent } from './features/users/createuser/createuser.component';
import { authChildGuard, authGuard } from './shell-global/auth/auth.guard';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login', // Changed from 'landing/summary'
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginpageComponent // Ensure LoginComponent is imported at the top
  },

  {
  path: 'change-password',canActivate: [authGuard],
  loadComponent: () =>
    import('./shell-global/changepassword/changepassword.component')
      .then(m => m.ChangepasswordComponent)
},
{
  path: 'forgot-password',
  loadComponent: () =>
    import('./shell-global/forgotpassword/forgotpassword.component')
      .then(m => m.ForgotpasswordComponent)
},
  {
  path: 'help',canActivate: [authGuard],
  loadComponent: () =>
    import('./shell-global/user-help/user-help.component')
      .then(m => m.UserHelpComponent)
},

 

{
    path: 'landing', canActivate: [authGuard], canActivateChild: [authChildGuard],


    loadComponent: () =>
      import('./shell-global/landing/landing.component')
        .then(m => m.LandingComponent),

    children: [
      {
  path: 'release-notes',canActivate: [authGuard],
  loadComponent: () =>
    import('./shell-global/release-notes/release-notes.component')
      .then(m => m.ReleaseNotesComponent)
},
      {
  path: 'pm-board',canActivate: [authGuard],
  loadComponent: () =>
    import('./features/project/pm-board/pm-board.component')
      .then(m => m.PmBoardComponent)
},

      
   

      {
        path: 'summary', data: {
          roles: ['manager', 'pmo']
        },
        loadComponent: () =>
          import('./features/summary/summary.component')
            .then(m => m.SummaryComponent)
      },

      // {
      //   path: 'timeline',
      //   loadComponent: () =>
      //     import('./features/timeline/timeline.component')
      //       .then(m => m.TimelineComponent)
      // },

      {
        path: 'backlog', data: {
          roles: ['manager', 'pmo']
        },
        loadChildren: () =>
          import('./features/backlog/backlog.module')
            .then(m => m.BacklogModule)
      },

      {
        path: 'sprints', data: {
          roles: ['manager', 'pmo']
        },
        loadChildren: () =>
          import('./features/sprints/sprints.module')
            .then(m => m.SprintsModule)
      },

      // {
      //   path: 'calendar',
      //   loadComponent: () =>
      //     import('./features/calendar/calendar.component')
      //       .then(m => m.CalendarComponent)
      // },

      {
        path: 'reports', data: {
          roles: ['manager', 'pmo']
        },
        loadComponent: () =>
          import('./features/reports/reports.component')
            .then(m => m.ReportsComponent)
      },

      {
        path: 'lists', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadComponent: () =>
          import('./features/lists/lists.component')
            .then(m => m.ListsComponent)
      },

      {
      path: 'allworks', data: {
          roles: ['manager', 'pmo']
        },
        loadComponent: () =>
          import('./features/allwork/allwork.component')
            .then(m => m.AllworkComponent)
      },
      {
        path: 'issue/:id', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadComponent: () =>
          import('./features/lists/viewissues/viewissues.component')
            .then(m => m.ViewissuesComponent)
      },

      {
        path: 'kanban', data: {
          roles: ['manager', 'pmo']
        },
        loadComponent: () =>
          import('./features/kanban/kanban.component')
            .then(m => m.KanbanComponent)
      },

      {
        path: 'timesheets', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadComponent: () =>
          import('./features/timesheets/timesheets.component')
            .then(m => m.TimesheetsComponent)
      },
           {
        path: 'upex-production', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/upexcise/upexcise-production/upexcise-production.module')
            .then(m => m.UpexciseProductionModule)
      },
        {
        path: 'upex-payment', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/upexcise/upexcise-payment/upexcise-payment.module')
            .then(m => m.UpexcisePaymentModule)
      },
        {
        path: 'upex-dis-pay', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/upexcise/upexcise-distribution/upexcise-distribution.module')
            .then(m => m.UpexciseDistributionModule)
      },
        {
        path: 'upex-license', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/upexcise/upexcise-license/upexcise-license.module')
            .then(m => m.UpexciseLicenseModule)
      },
       {
        path: 'upex-qa', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/upexcise/upexcise-qa/upexcise-qa.module')
            .then(m => m.UpexciseQAModule)
      },
       {
        path: 'upex-ba', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/upexcise/upexcise-ba/upexcise-ba.module')
            .then(m => m.UpexciseBAModule)
      },
          {
        path: 'trit', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/trichyit/trichyit.module').then(m => m.TrichyitModule)
      },
      {
        path: 'obdp',
        loadChildren: () =>
          import('./features/project/oasys-bigdata/oasys-bigdata.module')
            .then(m => m.OasysBigdataModule)
      },
      {
        path: 'ohrms', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/oasys-hrms/oasys-hrms.module')
            .then(m => m.OasysHrmsModule)
      },
      {
        path: 'cms', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/cms/cms.module')
            .then(m => m.CmsModule)
      },
      {
        path: 'redmine', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/redmine-migration2.0/redmine-migration2.0.module')
            .then(m => m.RedmineMigration20Module)
      },
      {
        path:'copt',
        loadChildren: () =>
          import('./features/project/cooptex/cooptex.module')
            .then(m => m.CooptexModule)
      },
      {
        path: 'oasprd', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/oasys-product/oasys-product.module')
            .then(m => m.OasysProductModule)
      },
               {
        path: 'fsp', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/Oasys FSP/oasys-fes.module')
            .then(m => m.OasysFESModule)
      },
      {
        path:'ocx',
        loadChildren: () =>
          import('./features/project/ocx/ocx.module')
            .then(m => m.OcxModule)
      },
      {
        path:'grc',
        loadChildren: () =>
          import('./features/project/oasys-grc/oasys-grc.module')
            .then(m => m.OasysGrcModule)
      },
      {
        path:'apex',data:{
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/apex/apex.module')
            .then(m => m.ApexModule)
      },
         {
        path:'lm',data:{
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/LS_MILLS/lsmills.module')
            .then(m => m.LsmillsModule)
      },
             {
        path:'erpc',data:{
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/ERPC/erpc.module')
            .then(m => m.ErpcModule)
      },
             {
        path:'pt',data:{
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/Prime Trip/primetrip.module')
            .then(m => m.PrimetripModule)
      },
             {
        path:'om',data:{
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/Oasys Mart/oasysmart.module')
            .then(m => m.OasysmartModule)
      },
      {
        path: 'erp', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/oasys-erp2.0/oasys-erp2.0.module')
            .then(m => m.OasysErp20Module)
      },
             {
        path: '1analytics', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/oneanalytics/oneanalytics.module')
            .then(m => m.OneanalyticsModule)
      },

      {
        path: 'users',

        children: [

          {
            path: '', data: {
              roles: ['pmo']
            },
            loadComponent: () =>
              import('./features/users/users.component')
                .then(m => m.UsersComponent)
          },

          {
            path: 'create', data: {
              roles: ['manager', 'pmo']
            },
            loadComponent: () =>
              import('./features/users/createuser/createuser.component')
                .then(m => m.CreateuserComponent)
          },
             {
      path: 'create/:id',
      data: {
        roles: ['manager', 'pmo']
      },
      loadComponent: () =>
        import('./features/users/createuser/createuser.component')
          .then(m => m.CreateuserComponent)
    }

        ]
      },

      // {
      //   path: 'servicedesk',
      //   loadComponent: () =>
      //     import('./features/servicedesk/servicedesk.component')
      //       .then(m => m.ServicedeskComponent)
      // },

      // {
      //   path: 'workflows',
      //   loadComponent: () =>
      //     import('./features/workflows/workflows.component')
      //       .then(m => m.WorkflowsComponent)
      // },

      // {
      //   path: 'activity',
      //   loadComponent: () =>
      //     import('./features/activity/activity.component')
      //       .then(m => m.ActivityComponent)
      // },
      {
        path: 'oss', data: {
          roles: ['manager','agent','pmo']
        },
        loadChildren: () =>
          import('./features/project/oss/oss.module').then(m => m.OssModule)
      },
      {
        path: 'ghmis', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/hmis/hmis.module').then(m => m.HmisModule)
      },
      {
        path: 'pds', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/pds/pds.module').then(m => m.PdsModule)
      },
          {
        path: 'tnpdsr', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/TNPDSREVAMPING/tnpdsrevamping.module').then(m => m.TnpdsrevampingModule)
      },
      {
        path: 'aiml', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/AIML/aiml.module')
            .then(m => m.AimlModule)
      },
      {
        path: 'iti', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/IT_Infra/it-infra.module')
            .then(m => m.ITInfraModule)
      },

      {
        path: 'its', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/IT_Support/it-support.module')
            .then(m => m.ITSupportModule)
      },

      {
        path: 'rdpd', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/RnD_Hardware/rnd-hardware.module')
            .then(m => m.RNDHardwareModule)
      },
         {
        path:'uiux', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/UI-UX/ui-ux.module')
            .then(m => m.UiUxModule)
      },

      {
        path: 'rdss', data: {
          roles: ['manager', 'agent', 'pmo']
        },
        loadChildren: () =>
          import('./features/project/RnD_Software/rnd-software.module')
            .then(m => m.RNDSoftwareModule)
      },



    ]
  },




];